import { getRequest, patchRequest, postRequest, deleteRequest } from 'services/requests';

export default {
    findCourse: (id) => getRequest(`/courses/${id}`),
    listCourses: () => getRequest(`/courses`),
    createCourse: (id, body) => postRequest(`/courses/${id}`, body),
    updateCourse: (id, body) => patchRequest(`/courses/${id}`, body),
    findCourseAccounts: (id) => getRequest(`/courses/${id}/accounts`),
    findCourseUsers: (id) => getRequest(`/courses/${id}/users`),
    listCourseAccounts: (id) => getRequest(`/courses/${id}/accounts`),
    listCourseUsers: (id) => getRequest(`/courses/${id}/users`),
    findCourseInstructors: (id) => getRequest(`/courses/${id}/instructors`),
    listChannels: (id) => getRequest(`/courses/${id}/channels`),
    readAllChannels: (id) => getRequest(`/courses/${id}/read-all`),
    listCourseActivities: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/activities?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    findCourseActivitiesGraph: ({ courseId, groupId, graphType, currentDateRange }) => {
        return getRequest(
            `/courses/${courseId}/activities-graph?$payload=${encodeURIComponent(
                JSON.stringify({
                    group_id: groupId,
                    graph_type: graphType,
                    currentDateRange,
                })
            )}`
        );
    },
    findCourseGroups: (id) => getRequest(`/courses/${id}/groups`),
    listCourseGroups: (id) => getRequest(`/courses/${id}/groups`),
    listCourseSharedUrls: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/shared-urls?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listCourseTasks: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/tasks?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listCourseFiles: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/files?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listCourseGroupFormations: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/group-formations?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listCourseGroupSurveys: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/surveys?$filter=${encodeURIComponent(filter)}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    findCourseAuthorities: (id) => getRequest(`/courses/${id}/authorities`),
    findCourseContribution: (id) => getRequest(`/courses/${id}/contributions`),
    findCourseContributions: (id) => getRequest(`/courses/${id}/contributions`),
    findCourseDistribution: (id) => getRequest(`/courses/${id}/distributions`),
    findCourseDistributions: (id) => getRequest(`/courses/${id}/distributions`),
    findCourseVariances: (id) => getRequest(`/courses/${id}/variances`),
    findCourseDraft: (id) => getRequest(`/courses/${id}/drafts`),
    findCourseCloningContents: (id) => getRequest(`/courses/${id}/clone-contents`),
    listGroupStatuses: (id) => getRequest(`/courses/${id}/group-statuses`),
    listTaskTemplates: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/task-templates?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listMilestones: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/courses/${id}/milestones?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
    listPeerEvaluations: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/peer-evaluations?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    listSubmissions: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/submissions?$filter=${encodeURIComponent(filter)}&$orderBy=${encodeURIComponent(
                orderBy
            )}&$skip=${skip}&$top=${top}`
        );
    },
    createLTIAssignmentSubmissions: (body) => postRequest('/publish-grades', body),
    createCourseTasks: (id, body) => postRequest(`/courses/${id}/tasks`, body),
    createCourseSharedUrls: (id, body) => postRequest(`/courses/${id}/shared-urls`, body),
    createCourseGroups: (id, body) => postRequest(`/courses/${id}/groups`, body),
    createCourseFiles: (id, body) => postRequest(`/courses/${id}/files`, body),
    createCourseChannels: (id, body) => postRequest(`/courses/${id}/channels`, body),
    createCourseActivity: (id, body) => postRequest(`/courses/${id}/activities`, body),
    createCoursePeerEvaluation: (id, body) => postRequest(`/courses/${id}/peer-evaluations`, body),
    upsertCourseDraft: (id, body) => postRequest(`/courses/${id}/drafts`, body),
    createCourseTaskTemplate: (id, body) => postRequest(`/courses/${id}/task-templates`, body),
    createCourseMilestone: (id, body) => postRequest(`/courses/${id}/milestones`, body),
    updateCourseDraft: (id, body) => patchRequest(`/courses/${id}/drafts`, body),
    updateCourseGroupSurvey: (id, body) => patchRequest(`/courses/${id}/surveys`, body),
    createCourseSubmission: (id, body) => postRequest(`/courses/${id}/submissions`, body),
    updateCourseSubmission: (id, body) => patchRequest(`/courses/${id}/submissions`, body),
    createCourseCloneContents: (id, body) => postRequest(`/courses/${id}/clone-contents`, body),
    listCourseSubmissions: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(
            `/courses/${id}/submissions?$filter=${encodeURIComponent(
                filter
            )}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`
        );
    },
    upsertCourseGroupFormation: (id, body) => postRequest(`/courses/${id}/group-formations`, body),
    createCourseSurvey: (id, body) => postRequest(`/courses/${id}/surveys`, body),
    updateCoursePeerEvaluation: (id, body) => patchRequest(`/courses/${id}/peer-evaluations`, body),
    deleteCourse: (id, body) => deleteRequest(`/courses/${id}`, body),
    deleteCourseSubmission: (id, body) => deleteRequest(`/courses/${id}/submissions`, body),
    deleteCoursePeerEvaluation: (id, body) => deleteRequest(`/courses/${id}/peer-evaluations`, body),
    createCourseFormative: (id, body) => postRequest(`/courses/${id}/formatives`, body),
    listCourseFormatives: (id, filter = null, orderBy = null, skip = null, top = null) => {
        return getRequest(`/courses/${id}/formatives?$filter=${filter}&$orderBy=${orderBy}&$skip=${skip}&$top=${top}`);
    },
};
